import * as urls from "../../../api/urls";
import React, { useEffect, useRef, useState } from "react";
import { Utils } from "helpers/utils";
import { APIClient } from "api/apiCore";
import AppSimpleBar from "components/AppSimpleBar";
import Loader from "components/Loader";
import MasterPage1Column from "pages/MasterPage1Column";
import LoadingIconWithText from "components/LoadingIconWithText";
import TextBox from "components/TextBox";
import classnames from "classnames";
import { useDialog } from "DialogProvider";
import { RecuranceModes } from "const";
import { useCursorPopup, useRedux } from "hooks";
import SelectDropdown from "components/SelectDropdown";
import Select, { components, OptionProps, SingleValueProps, DropdownIndicatorProps, IndicatorSeparatorProps, useStateManager } from 'react-select';
import UserAvatarWithName from "components/UserAvatarWithName";
import { UserTypes } from "api";

interface sp_SearchExternalUser {
  displayName2?: string | null;
  companyName?: string | null;
  departmentName?: string | null;
  positionName?: string | null;
  authMobileNo?: string | null;
  isActive?: boolean | null;
  userId?: number | null;
  pictureUrl?: string | null;
  email?: string | null;
  lastConnectDate?: Date | null;
  hdrId1?: number | null;
  hdrDisplayName2?: string | null;
  hdrCompanyName?: string | null;
  hdrDepartmentName?: string | null;
  hdrPositionName?: string | null;
  hdrAuthMobileNo?: string | null;
  hdrIsActive?: boolean | null;
  hdrUserId?: number | null;
  hdrPictureUrl?: string | null;
  hdrEmail?: string | null;
  hdrLastConnectDate?: Date | null;
  divisionName?: string | null;
  hdrDivisionName?: string | null;
}



interface MainComponentProps {
  // onTaskCountChanged(taskCount: number): void;
}

// const MainComponent: React.FC<{ taskCount }> = ({ taskCount: number }) => {
const MainComponent = ({ }: MainComponentProps) => {
  const { dispatch, useAppSelector } = useRedux();
  const [loading, setLoading] = useState<boolean>(false);
  const [data, setData] = useState<sp_SearchExternalUser[]>([]);
  const [ddlCompany, setDdlCompany] = useState<any[]>([]);
  const [ddlCompanySelected, setDdlCompanySelected] = useState<any>();


  useEffect(() => {
    try {
      new APIClient().fnPostForm(urls.WP_GET_DLL_VALUE_EXTERNAL_USER_FILTER, { groupBy: "Company" })
        .then(rs => setDdlCompany(rs));
    } catch (e) { console.error(e); }
  }, []);

  useEffect(() => {
    fnSearch();
  }, []);


  const fnSearch = async () => {
    setLoading(true);
    const parm = {
      companyNames: ddlCompanySelected ?? null,
    }
    new APIClient().fnPostForm(urls.WP_SEARCH_EXTERNAL_USER, parm)
      .then(rs => {
        setData(rs);
        setLoading(false);
      })
      .catch(er => {
        Utils.HandleException(er, true);
        setLoading(false);
      });
  }

  useEffect(() => {
    fnSearch();
  }, [ddlCompanySelected]);

  const fnUpdateUserRow = async (userId: number | null, isDelete: boolean) => {
    if (userId) {
      if (isDelete) {
        setData(prev => prev.filter(x => x.userId !== userId));
      } else { // update
        new APIClient().fnPostForm(urls.WP_SEARCH_EXTERNAL_USER, { userId: userId })
          .then(rs => {
            if (rs.length === 1) {
              const usr = rs[0];
              setData(prev => {
                const exists = prev.some(t => t.userId === usr.userId);

                if (exists) {
                  return prev.map(x =>
                    x.userId === usr.userId ? usr : x
                  );
                } else {
                  return [...prev, usr];
                }
              });
            }
          });
      }
    }
  }

  const dialog = useDialog();
  const fnEdit = async (userId: number) => {
    const newUserId = await dialog.showUserInfo({ userId: userId, allowEdit: true, userType: UserTypes.ExternalUser });
    console.log('userId:', newUserId);
    if (newUserId !== -1) { // user not click cancel
      await fnUpdateUserRow(userId, userId != newUserId);
    }
  }
  const fnAdd = async () => {
    const newUserId = await dialog.showUserInfo({ userId: null, allowEdit: true, userType: UserTypes.ExternalUser });
    console.log('userId:', newUserId);
    await fnUpdateUserRow(newUserId, false);
  }

  const [subTask, setSubTask] = useState<any[]>([]);
  const [curTaskInPop, setCurTaskInPop] = useState<string>("");
  const [subTaskLoading, setSubTaskLoading] = useState<boolean>(false);
  const [showSubTaskDialog, setShowSubTaskDialog] = useState<boolean>(false);
  const { ref: popRef, pos: popCur, openAtCursor } = useCursorPopup(
    showSubTaskDialog,
    () => setShowSubTaskDialog(false)
  );

  const Option = ({ data, isOption }: { data: any, isOption: boolean }) => {
    return (
      <div className="xyz12 d-flex justify-content-between align-items-center" style={{ gap: 8 }}>
        <span className={isOption ? "ps-2" : ""}>{data.label}</span>
        <span className={isOption ? "pe-3" : ""}>{data.count}</span>
      </div>
    );
  }

  const CustomOption = (props: OptionProps<any>) => {
    const { data } = props;
    return (<components.Option {...props}><Option data={data} isOption={true} /></components.Option>);
  };

  const CustomSingleValue = (props: SingleValueProps<any>) => {
    const { data } = props;
    return (<components.SingleValue {...props}><Option data={data} isOption={false} /></components.SingleValue>);
  };

  return (
    <div>
      <div className="d-flex justify-content-between" style={{ gap: "10px" }}>
        <div className="row " style={{ flexGrow: "1" }}>
          <div className="col">
            <SelectDropdown
              isDisabled={false}
              list={ddlCompany}
              selectedValue={ddlCompany.find(x => x.value == ddlCompanySelected)}
              onValueChanged={(e) => { setDdlCompanySelected(e);  }}
              customOption={CustomOption}
              customValue={CustomSingleValue}
              placeholder={"บริษัท"}
              isMulti={false}
            />
          </div>
          <div className="col"></div>
          <div className="col"></div>
        </div>
        <div className="input-group-append " >
          <button className="btn btn-primary" type="submit" onClick={fnSearch}>Refresh</button>
          &nbsp;
          <button className="btn btn-warning" type="submit" onClick={fnAdd}>เพิ่ม</button>
        </div>
      </div>
      <div style={{ height: "5px" }}></div>
      {loading && (<Loader />)}
      <div className="div-table-fix-header" style={{ height: "calc(100vh - 120px)" }}>
        <table >
          <thead >
            <tr>
              <th align="center">ชื่อ</th>
              <th align="center">บริษัท</th>
              <th align="center">หน่วยงาน</th>
              <th align="center">แผนก</th>
              <th align="center">ตำแหน่ง</th>
              <th align="center">มือถือ</th>
              <th align="center">เข้าระบบล่าสุด</th>
            </tr>
          </thead>
          <tbody>
            {!loading && data.length <= 0 && (<tr><td align="center" colSpan={7}>ไม่มีข้อมูล</td></tr>)}
            {data.map((ext, index) => {
              return (
                <tr key={index} className={classnames("hand hover", { "text-gray": !ext.isActive })} onClick={(e) => fnEdit(ext.userId!)} >
                  <td>
                    <UserAvatarWithName abbrName="" backColor="" displayName2={ext.displayName2 ?? ""} foreColor="" keyValue={index} profileImage={ext.pictureUrl ?? ""} userId={ext.userId ?? -1} />
                  </td>
                  <td>{ext.companyName}</td>
                  <td>{ext.divisionName}</td>
                  <td>{ext.departmentName}</td>
                  <td>{ext.positionName}</td>
                  <td>{ext.authMobileNo}</td>
                  <td>{Utils.GetDMYHHMM(ext.lastConnectDate)}</td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const DataSettingExternalUser = () => {

  const onSetEditCol2Key = (e: any) => {

  }
  return (
    <MasterPage1Column
      titleText={"ข้อมูล external user"}
      titleIcon="fas fa-user-ninja"
      // editCol2Key={editId}
      onSetEditCol2Key={onSetEditCol2Key}
      // capCol2={title2}
      componentCol1={<MainComponent />}
    // componentCol2={<CategoryEdit editId={editId} onCatChange={onCatChange} canEdit={canEdit} />}
    ></MasterPage1Column>
  );
}

export default DataSettingExternalUser;